module.exports = __webpack_public_path__ + "img/skyline-london-eye@2x.661fe56.png";